export const BOOKS_SLUG = 'books';
export const BOOKS_ROUTE = '/books';
/** The financial-read permission published for other module catalogs to include. */
export const BOOKS_READ_PERMISSION = 'books:read';
/** The export act's own string: an Owner holds it, a Member does not. */
export const BOOKS_EXPORT_PERMISSION = 'books:export';
export const BOOKS_PAGE_TEST_ID = 'page-books';

/**
 * Every Books address beneath the mount, permanent: a statement's scope is in its search, so a
 * statement can be linked to. Each host registers these as its own routes, over the shared page.
 */
export const BOOKS_ROUTES = {
  overview: BOOKS_ROUTE,
  statements: `${BOOKS_ROUTE}/statements`,
  statement: `${BOOKS_ROUTE}/statements/$statement`,
  ledger: `${BOOKS_ROUTE}/ledger`,
  journal: `${BOOKS_ROUTE}/ledger/journal`,
  account: `${BOOKS_ROUTE}/ledger/accounts/$accountCode`,
  reconciliation: `${BOOKS_ROUTE}/reconciliation`,
  export: `${BOOKS_ROUTE}/export`,
} as const;

/** Which Books page an address shows: the host route names it, with its params. */
export type BooksView =
  | { page: 'overview' }
  | { page: 'statements'; statement: string | null }
  | { page: 'ledger' }
  | { page: 'journal' }
  | { page: 'account'; accountCode: string }
  | { page: 'reconciliation' }
  | { page: 'export' };

/** The address of a page beneath the mount, its params encoded. */
export function booksPath(view: BooksView): string {
  switch (view.page) {
    case 'overview':
      return BOOKS_ROUTES.overview;
    case 'statements':
      return view.statement === null
        ? BOOKS_ROUTES.statements
        : `${BOOKS_ROUTES.statements}/${encodeURIComponent(view.statement)}`;
    case 'ledger':
      return BOOKS_ROUTES.ledger;
    case 'journal':
      return BOOKS_ROUTES.journal;
    case 'account':
      return `${BOOKS_ROUTES.ledger}/accounts/${encodeURIComponent(view.accountCode)}`;
    case 'reconciliation':
      return BOOKS_ROUTES.reconciliation;
    case 'export':
      return BOOKS_ROUTES.export;
  }
}
